/**
 * Copy for the public /alerts training geo-alerts landing (SSR + client).
 * Hermes may supply finals later — keep client + server in sync here.
 */

export const TRAINING_ALERTS_LANDING_H1 = 'Get training alerts by email';

export const TRAINING_ALERTS_LANDING_DOCUMENT_TITLE =
  'Get Training Alerts by Location | American Police Training';

export const TRAINING_ALERTS_LANDING_META_DESCRIPTION =
  'Get email alerts when new law enforcement training is posted in your state or counties. Subscribe with email and manage later with an optional account.';

export const TRAINING_ALERTS_LANDING_INTRO =
  'Choose the states and counties where you train. We email you when new courses are posted in those areas — no need to check the directory every day.';

export const TRAINING_ALERTS_LANDING_BULLETS = [
  'Alerts by state and county — focus on where you work or travel for training.',
  'Subscribe with your email, confirm from the link we send, and start getting alerts.',
  'Unsubscribe anytime, or create an optional account later to manage alerts in your dashboard.',
] as const;

export const TRAINING_ALERTS_LANDING_PRIMARY_CTA = 'Get training alerts by email';

export const TRAINING_ALERTS_LANDING_AUTH_WALL_BODY =
  'Create a free account or sign in to manage your training alert settings from your dashboard and keep them synced across devices.';

export const TRAINING_ALERTS_LANDING_EVENTS_LINK_LABEL =
  'Browse upcoming training events';
